import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MarkdownComponent} from './markdown.component';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatInputModule} from '@angular/material/input';
import {FormbirdServicesModule} from 'formbird-services';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { default as pjson } from '../../../../../package.json';

@NgModule({
  declarations: [
    MarkdownComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatTooltipModule,
        MatInputModule,
        ComponentSetupModule,
        FormbirdServicesModule,
        MatProgressBarModule
    ]
})
export class MarkdownModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(MarkdownComponent, 'sc-markdown', this.injector, pjson.version);

  }
}
